module.exports = __webpack_public_path__ + "static/media/Rosato.2dd68c58.png";